goog.module('yext.location.UberTripBranding');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');
const NamedUrl = goog.require('yext.location.NamedUrl');
const textfield = goog.require('yext.textfield');

/**
 * This module powers the Uber trip branding field
 *
 * @author MattJS (matt@yext.com)
 */

/**
 * The uber trip branding field composes a namedUrl with additional properties
 *
 * @param {!jQuery} $ctx Context for the module
 * @constructor
 */
const UberTripBranding = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = $ctx.find('.js-field-value');
  this.fieldId = $ctx.find('.js-uber-trip-branding-edit').data('fieldId');
  this.namedUrl = new NamedUrl($ctx);
  this.description = textfield.createWithUsageType($ctx.find('.js-uber-trip-branding-description'), this.fieldId),

  this.$content = $ctx.find('.js-uber-trip-branding-content');
  this.$previewDesc = this.$content.find('.js-branding-preview-description');
  this.$previewDescEmpty = this.$content.find('.js-branding-preview-description-empty');
  this.$previewUrl = this.$content.find('.js-branding-preview-url');
  this.$previewUrlEmpty = this.$content.find('.js-branding-preview-url-empty');

  // This is the stored value of indeterminate
  this.indeterminate = $ctx.find('.js-uber-trip-branding-edit').data('indeterminate');

  this.setFieldJSONValue();
  this.bindings();
  this.bindIndeterminate();
};

/**
 * Bind the indeterminate reset link
 */
UberTripBranding.prototype.bindIndeterminate = function() {
  var self = this;
  this.$ctx.find('.js-reset-indeterminate').click(function() {
    self.toggleIndeterminate(false);
  });
};

UberTripBranding.prototype.bindings = function() {
  var self = this;
  this.namedUrl.bindings();

  $(this.namedUrl).on('updated', function() {
    self.message('updated');
    self.livePreview();
    self.setFieldJSONValue();
  });

  $(this.description).on('update.textField', function() {
    self.message('updated');
    self.livePreview();
    self.setFieldJSONValue();
  });
};

/**
 * Will be called to update the live preview as the field is edited
 */
UberTripBranding.prototype.livePreview = function() {
  var hasUrl = !!this.namedUrl.url.value();
  var hasMsg = !!this.namedUrl.name.value();
  var hasDesc = !!this.description.model.value;

  this.$previewDesc.toggle(hasDesc);
  this.$previewDescEmpty.toggle(!hasDesc);

  if (hasDesc) {
    this.$previewDesc.html(helpers.escapeInput(this.description.model.value));
  }

  this.$previewUrl.toggle(hasMsg);
  this.$previewUrlEmpty.toggle(!hasMsg);

  if (hasMsg) {
    var label = '';
    if (this.namedUrl.name.model.asset) {
      label = this.namedUrl.name.model.asset.data;
    } else {
      label = helpers.escapeInput(this.namedUrl.name.value());
    }
    this.$previewUrl.html(label);
  }

  if (hasUrl) {
    this.setPreviewLink(this.namedUrl.url.value());
  } else {
    this.clearPreviewLink();
  }
};

/**
 * Sets the preview link to the hash character
 */
UberTripBranding.prototype.clearPreviewLink = function() {
  this.$previewUrl.attr({
    href: '#',
  }).removeAttr('target');

  this.$previewUrlEmpty.attr({
    href: '#',
  }).removeAttr('target');
};

/**
* Sets the preview link to the given URL
*/
UberTripBranding.prototype.setPreviewLink = function(url) {
  this.$previewUrl.attr({
    href: helpers.preprendProtocol(url),
    target: '_blank',
  });

  this.$previewUrlEmpty.attr({
    href: helpers.preprendProtocol(url),
    target: '_blank',
  });
};

/**
 * Updates the field with new values
 *
 * @param {!Object} field Updated field data
 */
UberTripBranding.prototype.set = function(field) {
  this.namedUrl.set(field);
  this.description.set(field['description']);
  this.setIndeterminate(field['indeterminate']);
};

/**
 * Sets the value and then calls toggleIndeterminate to update the UI
 *
 * @param {boolean} indeterminate
 */
UberTripBranding.prototype.setIndeterminate = function(indeterminate) {
  this.indeterminate = indeterminate;
  this.toggleIndeterminate(indeterminate);
};

/**
 * Toggles the UI indeterminate state
 *
 * @param {boolean} indeterminate
 */
UberTripBranding.prototype.toggleIndeterminate = function(indeterminate) {
  this.$ctx.find('.js-indeterminate-message').toggle(indeterminate);
  this.$ctx.find('.js-edit-buttons').toggle(!indeterminate);
  this.$ctx.find('.js-uber-trip-branding-preview').toggle(!indeterminate);
  this.$ctx.find('.js-uber-trip-branding-wrapper').toggle(!indeterminate);
};

/**
 * Generates the display mode for the field
 *
 * @return {string} Html string
 */
UberTripBranding.prototype.getDisplayValue = function() {
  return this.namedUrl.getDisplayValue();
};


/**
 * Broadcast a message with the instance as context
 * @param {string} message
 */
UberTripBranding.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Save the current state of this field
 */
UberTripBranding.prototype.saveState = function() {
  this.namedUrl.saveState();
  this.description.saveValue();
  this.storedIndeterminate = this.indeterminate;
};

/**
 * Get the plain version of this field's data
 *
 * @return {!Object}
 */
UberTripBranding.prototype.data = function() {
  var data = this.namedUrl.data();
  data.description = this.description.coreData();
  data.indeterminate = this.indeterminate;
  return data;
};

/**
 * Restore the state of the url to a stored value
 */
UberTripBranding.prototype.reset = function() {
  this.namedUrl.reset();
  this.description.reset();
  this.indeterminate = this.storedIndeterminate;
};

/**
 * Sets a hidden input to the value of the field as JSON
 */
UberTripBranding.prototype.setFieldJSONValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.data()));
};

exports = UberTripBranding;
